import { useSelector } from 'store/store'
import { Skeleton } from '@mui/material'
import { SectionCard, Typography } from 'components'

import * as S from './styles'

export const CommercialSection = () => {
  const {
    detailedInfo: { EstruturaComercial },
    loadingDetailedInfo: loading
  } = useSelector((state) => state.ov)

  return (
    <SectionCard
      title="Estrutura comercial"
      tooltipText="Nesta seção você pode consultar a estrutura comercial na qual está alocado o cliente desta OV. Esses dados podem afetar a disponibilidade e preços de materiais."
    >
      <S.Wrapper>
        <S.TextRow>
          <S.TextCol>
            <S.InfoItem>
              <Typography design="hav-default-02-text">Canal de Distribuição</Typography>
              {loading ? (
                <Skeleton height={30} />
              ) : (
                <Typography>{EstruturaComercial.CanalDistribuicao}</Typography>
              )}
            </S.InfoItem>
            <S.InfoItem>
              <Typography design="hav-default-02-text">Escritório de Venda</Typography>
              {loading ? (
                <Skeleton height={30} />
              ) : (
                <Typography>{EstruturaComercial.EscritorioVenda}</Typography>
              )}
            </S.InfoItem>
          </S.TextCol>
          <S.TextCol>
            <S.InfoItem>
              <Typography design="hav-default-02-text">Setor de atividade</Typography>
              {loading ? (
                <Skeleton height={30} />
              ) : (
                <Typography>{EstruturaComercial.SetorAtividade}</Typography>
              )}
            </S.InfoItem>
            <S.InfoItem>
              <Typography design="hav-default-02-text">Equipe de Venda</Typography>
              {loading ? (
                <Skeleton height={30} />
              ) : (
                <Typography>{EstruturaComercial.EquipeVenda}</Typography>
              )}
            </S.InfoItem>
          </S.TextCol>
        </S.TextRow>
        <S.TextRow>
          <S.InfoItem>
            <Typography design="hav-default-02-text">Região de Venda</Typography>
            {loading ? (
              <Skeleton height={30} />
            ) : (
              <Typography>{EstruturaComercial.RegiaoVenda}</Typography>
            )}
          </S.InfoItem>
        </S.TextRow>
      </S.Wrapper>
    </SectionCard>
  )
}
